"use strict";

angular.module('app.api.errorHandling', []). // app.factories.devices-module

// -------------------------------------------//
//             Error Factory
// -------------------------------------------//
factory('_err', ['$document', '$http', 'f_Interval', '$timeout', '$cacheFactory', 'errorDotModal',
    function ($document, $http, f_Interval, $timeout, $cacheFactory, errorDotModal) {
        var errorBundleId = undefined;
        var errors = {};
        var errorHandling = {
            add: function (errorMessage) {
                function guid() {
                    function s4() {
                        return Math.floor((1 + Math.random()) * 0x10000)
                            .toString(16)
                            .substring(1);
                    }
                    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                        s4() + '-' + s4() + s4() + s4();
                }

                var date = new Date();                           
                // start error collection
                if (!errorBundleId) {
                    errorBundleId = guid();
                    // create new error bundle
                    errors[errorBundleId] = {
                        date: date,
                        errorList: [errorMessage]
                    };

                    // define interval for error search
                    var search = function () {
                        if ($http.pendingRequests.length === 0){
                            errorBundleId = undefined;
                        } else {
                            $timeout(search, 50);
                        }
                    };
                    $timeout(search, 50);
                } else {
                    errors[errorBundleId].errorList.push(errorMessage);
                }

                errorMessage.BundleId = errorBundleId;
                errorMessage.ErrorId = errors[errorBundleId].errorList.length - 1;
                return errorMessage;
            },
            getError: function (bundleId, errorId) {
                return errors[bundleId].errorList[errorId];
            },
            getBundle: function (bundleId) {
                return errors[bundleId];
            },
            log: function (object, ticketId, description) {
                var m = '';
                if(object && object.$UI && object.$UI.errorMessage && object.$UI.errorMessage.BundleId){
                    m = object.$UI.errorMessage.BundleId;
                }
                errorDotModal(m, ticketId, description);
            }
        };

        return errorHandling;
    }
]);